import { Grid, GridItem } from "@drone-js/core";
import type { LocationDropdownItem, ProfileData } from "libs/codegen/property-onboarding";
import type { FunctionComponent } from "react";
import { type FieldPath, useFormContext } from "react-hook-form";
import { DropdownField } from "../form/DropdownField";
import { useStaticDataAtomValue } from "../staticDataAtom";
import { useStateCityList } from "./useStateCityList";

type ValidPath = FieldPath<ProfileData>;

interface Props {
    fieldPrefix: string;
    dataElementName?: string;
}

export const CityStateDropdown: FunctionComponent<Props> = ({ fieldPrefix, dataElementName }) => {
    const { states, cities } = useStateCityList(fieldPrefix);
    const {
        cmsData: {
            location: { youMustSelectACountryRegion },
            profile: { stateOrProvince, stateOrProvinceRequired, city, cityRequired },
        },
    } = useStaticDataAtomValue();
    const { setValue } = useFormContext();

    return (
        <Grid spacing="16">
            <GridItem sm={12} md={6}>
                <DropdownField<ProfileData>
                    label={stateOrProvince}
                    field={`${fieldPrefix}.state` as ValidPath}
                    items={states}
                    rules={{
                        required: stateOrProvinceRequired,
                        validate: {
                            notEmpty: (v) =>
                                (v !== null && (v as LocationDropdownItem).id !== 0) || stateOrProvinceRequired,
                        },
                    }}
                    onChange={() => {
                        setValue(`${fieldPrefix}.city`, undefined);
                    }}
                    blankState={youMustSelectACountryRegion}
                    dataElementName={dataElementName ? dataElementName + "-residence-info-state" : ""}
                />
            </GridItem>
            <GridItem sm={12} md={6}>
                <DropdownField<ProfileData>
                    label={city}
                    field={`${fieldPrefix}.city` as ValidPath}
                    items={cities}
                    rules={{
                        required: cityRequired,
                        validate: {
                            notEmpty: (v) => (v !== null && (v as LocationDropdownItem).id !== 0) || cityRequired,
                        },
                    }}
                    blankState={youMustSelectACountryRegion}
                    dataElementName={dataElementName ? dataElementName + "-residence-info-city" : ""}
                />
            </GridItem>
        </Grid>
    );
};
